var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.955078H513V114.955H0V0.955078Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 114.955H513V228.955H0V114.955Z",
    fill: "#203899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228.955H513V342.955H0V228.955Z",
    fill: "#D82B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.564 123.617L279.756 134.105L290.016 137.297L281.124 143.453L281.352 154.397L272.688 147.785L262.428 151.205L265.848 141.173L259.464 132.509H270.18L276.564 123.617ZM236.208 123.617L242.364 132.509H253.08L246.696 141.173L250.116 151.433L239.856 147.785L231.192 154.169L231.42 143.453L222.528 137.069L232.788 134.105L236.208 123.617ZM314.64 136.385L314.412 147.329L323.304 153.485L312.816 156.677L309.624 166.937L303.468 158.273H292.524L299.136 149.609L295.716 139.349L305.976 142.997L314.64 136.385ZM198.132 136.841L207.252 142.997L217.284 138.893L214.32 149.381L221.16 157.589L210.444 158.045L204.516 167.165L200.868 157.133L190.38 154.397L198.816 147.557L198.132 136.841ZM347.472 163.517L342.912 173.549L348.612 182.669L337.896 181.529L330.828 189.737L328.548 179.249L318.744 175.145L328.092 169.673L328.776 158.957L336.756 166.025L347.472 163.517ZM351.804 189.053L356.592 198.857L367.308 200.453L359.556 207.977L361.38 218.465L351.804 213.449L342.228 218.465L344.052 207.977L336.3 200.453L347.016 198.857L351.804 189.053ZM159.6 187.913L164.388 197.717L175.104 199.085L167.352 206.609L169.176 217.325L159.6 212.309L150.024 217.325L151.848 206.609L144.096 199.085L154.812 197.717L159.6 187.913ZM166.668 161.693L176.928 164.885L185.592 158.273V169.217L194.484 175.145L184.224 178.565L181.26 189.053L174.876 180.389L164.16 180.617L170.316 171.953L166.668 161.693Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.955078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVe);
export default __webpack_public_path__ + "static/media/VE.bf9ca5cd0dcbfeb3773bcc9a3ca98121.svg";
export { ForwardRef as ReactComponent };